import React, { useState } from "react";
import RadioGroup from "../../atoms/RadioGroup";
import DropDowns from "./DropDowns";
import Button from "../../atoms/Button";
import Table from "../../atoms/Table";
import { fetchReportsTotalUsers } from "../../../utils/api/getReports";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import arrow from "../../../assets/svgs/downarrow.svg";
import SpecificTimePeriod from "./SpecificTimePeriod";
import Pagination from "../../atoms/Pagination";

const tableHeader = [ "ID" , "Name", "Email", "Type", "Number", "location", "Registered Date"];

const options = [
  { label: "This Week", value: "this-week" },
  { label: "Last Week", value: "last-week" },
  { label: "This Month", value: "this-month" },
  { label: "Last Month", value: "last-month" },
  { label: "Select Specific Time Period", value: "specificTimePeriod" }
];

const FilterComponent = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [openTable, setOpenTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  // const [displayData, setDisplayData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [currPage, setCurrPage] = useState(1);
  const limit = 10;

  const handleSelectedTimePeriod = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
    updateDates(value);
  };
  const updateDates = (value) => {
    const today = new Date();
    let start = new Date();
    let end = new Date();

    switch (value) {
      case "thisWeek":
        const dayOfWeek = today.getDay();
        const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        start = new Date(today.setDate(diff));
        end = new Date(today.setDate(diff + 6));
        break;
      case "lastWeek":
        const lastWeekStart = new Date();
        const lastWeekEnd = new Date();
        lastWeekStart.setDate(today.getDate() - today.getDay() - 6);
        lastWeekEnd.setDate(today.getDate() - today.getDay());
        start = lastWeekStart;
        end = lastWeekEnd;
        break;
      case "thisMonth":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case "lastMonth":
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      default:
        start = "";
        end = "";
    }

    setStartDate(start ? start.toISOString().split("T")[0] : "");
    setEndDate(end ? end.toISOString().split("T")[0] : "");
  };

  const handleSubmit = async (page = 1) => {
    setLoading(true);
    setError("");
    const durationValue =
      selectedOption === "specificTimePeriod" ? "" : selectedOption;

    const apiParams = {
      duration: durationValue,
      fromDate: startDate,
      toDate: endDate,
      page  ,  
      limit 
    };
    const capitalize = (str) => {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };
    // const tableHeader = [ "ID" , "Name", "Email", "Type", "Number", "location", "Registered Date"];

    try {
      const foramteDate = (date) => {
       if(!date)  return "N/A"

       return new Date(date)
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-")

      }
      const data = await fetchReportsTotalUsers(apiParams , ()=>{});
      const formattedData = data.map((users) => [
        users.user_id,
        users.name,
        users.email,
        capitalize(users.user_type ? users.user_type.toString() : ""),
         (  (users?.contact_number?.country_code||"")+ " "+ (users?.contact_number?.phone_no ||"N/A") ),
        users?.location||" N/A",
        foramteDate(users.createdAt)
      ]);

      setTableData(formattedData);
      // setDisplayData(formattedData.slice(0, limit));
      setOpenTable(true);
    } catch (err) {
      setError("Failed to fetch Total Users");
      console.error("Error fetching Total Users:", err);
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      tableData.map((row, index) =>
        tableHeader.reduce(
          (acc, header, idx) => ({
            ...acc,
            [header]: row[idx]
          }),
          {}
        )
      )
    );
    const getMaxColWidth = (colIndex) => {
      let maxColWidth = tableHeader[colIndex]
        ? tableHeader[colIndex].toString().length
        : 10;
      tableData.forEach((row) => {
        const cellValue = row[colIndex] ? row[colIndex].toString() : "";
        maxColWidth = Math.max(maxColWidth, cellValue.length);
      });

      return maxColWidth + 2;
    };

    worksheet["!cols"] = tableHeader.map((_, colIndex) => ({
      wch: getMaxColWidth(colIndex)
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Total Users Report");
    XLSX.writeFile(workbook, "report.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.text("Total Users Report", 14, 20);
    doc.autoTable({
      startY: 30,
      head: [tableHeader],
      body: tableData
    });
    doc.save("report.pdf");
  };

  const totalPages = (tableData.length === 10 ?currPage+1 :currPage) ;

  const onNext = () => {
    if (currPage < totalPages) {
      const nextPage = currPage + 1;
      // const startIdx = (nextPage - 1) * limit;
      // const endIdx = startIdx + limit;
      // setDisplayData(tableData.slice(startIdx, endIdx));
      setCurrPage(nextPage);
      handleSubmit(nextPage)

    }
  };

  const onPrev = () => {
    if (currPage > 1) {
      const prevPage = currPage - 1;
      // const startIdx = (prevPage - 1) * limit;
      // const endIdx = startIdx + limit;
      // setDisplayData(tableData.slice(startIdx, endIdx));
      setCurrPage(prevPage);
      handleSubmit(prevPage)

    }
  };

  return (
    <div className="bg-gray-100">
      <div className="w-full bg-white text-4xl px-7 rounded-2xl py-5">
        <p className="text-xs text-gray-500">Time Period</p>
        <RadioGroup options={options} onChange={handleSelectedTimePeriod} />
        {selectedOption === "specificTimePeriod" && (
          <div className="py-4">
            <p className="text-xs text-gray-500">Time Period</p>
            <SpecificTimePeriod
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
        )}
        <div className="flex gap-4 py-5">
          <Button
            color={"blue"}
            varient={"primary"}
            className="text center w-80 py-2 text-white text-xl font-normal "
            onClick={ () =>handleSubmit(1)}
            disabled={loading}
          >
            {loading ? "Loading..." : "Submit"}
          </Button>
          <Button
            color={"lightblue"}
            varient={"primary"}
            className="text center w-80 py-2 text-blue-800 text-xl font-normal "
            onClick={() => setOpenTable(false)}
          >
            Cancel
          </Button>
        </div>
        {error && <p className="text-red-500">{error}</p>}
      </div>
      {openTable && tableData.length > 0 && (
        <div className="w-full  py-5 mt-4 pr-8">
          <div className="flex justify-end gap-5 pb-3 pr-6">
            <Button
              color={"blue_800"}
              varient={"primary"}
              className={
                "text-white flex justify-center items-center px-9 text-[9px] py-2 font-bold"
              }
              onClick={downloadPDF}
            >
              <img src={arrow} alt="SVG icon" className="w-2.5 h-2.5 mr-1" />
              Pdf
            </Button>
            <Button
              color={"blue_800"}
              varient={"primary"}
              className={
                "text-white flex justify-center items-center px-8 text-[9px] py-2 font-bold"
              }
              onClick={downloadExcel}
            >
              <img src={arrow} alt="icon" className="w-2.5 h-2.5 mr-2" />
              Excel
            </Button>
          </div>
          <div className="w-full bg-white text-4xl px-7 rounded-2xl py-5 my-4">
            <Table data={tableData} headerData={tableHeader} />
          </div>
          {totalPages > 1 && (
            <Pagination
              currPage={currPage}
              onNext={onNext}
              onPrev={onPrev}
              totalPages={totalPages}
            />
          )}
        </div>
      )}
      {openTable && tableData.length === 0 && (
        <div className="text-center text-xl py-4">
          No user found for the selected filters.
        </div>
      )}
    </div>
  );
};

export default FilterComponent;
